import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  minHeight: "100dvh",
  width: "100%",
};

export const main: SxProps<Theme> = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  minHeight: 0,
  width: "100%",
  pb: { xs: 8, md: 0 },
};

